import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function DietaryRestrictionDropdown({ onSelect, selectedRestrictions, singleSelect, label }) {
    const [selectedItems, setSelectedItems] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);

    const items = [
        { item_id: '', name: 'All' },
        { item_id: 'Standard', name: 'Standard' },
        { item_id: 'Gluten Free', name: 'Gluten Free' },
        { item_id: 'Cardiac / Diabetic', name: 'Cardiac / Diabetic' },
        { item_id: 'Renal Therapeutic', name: 'Renal Therapeutic' },
        { item_id: 'Lactose Free', name: 'Lactose Free' },
    ];

    useEffect(() => {
        if (!selectedRestrictions) return;
        let newSelectedItems;
        if (singleSelect) {
            const value = Array.isArray(selectedRestrictions)
              ? selectedRestrictions[0]
              : selectedRestrictions;
            newSelectedItems = items.filter(item => item.name === value);
        } else {
            newSelectedItems = selectedRestrictions
                .map(sel => items.find(item => item.name === (sel.name || sel)))
                .filter(Boolean);
        }
        setSelectedItems(newSelectedItems);
    }, [selectedRestrictions, singleSelect]);

    const toggleDropdown = () => setShowDropdown(!showDropdown);

    const handleSelectItem = (item) => {
        if (singleSelect) {
            setSelectedItems([item]);
            setShowDropdown(false);
            onSelect([item]);
        } else {
            if (item.item_id === '') {
                setSelectedItems([item]);
                onSelect([item]);
            } else {
                let newSelectedItems = selectedItems.filter(selected => selected.item_id !== '');
                const exists = newSelectedItems.find(selected => selected.item_id === item.item_id);
                if (exists) {
                    newSelectedItems = newSelectedItems.filter(selected => selected.item_id !== item.item_id);
                } else {
                    newSelectedItems = [...newSelectedItems, item];
                }
                if (newSelectedItems.length === 0) {
                    newSelectedItems = items.filter(it => it.item_id === '');
                }
                setSelectedItems(newSelectedItems);
                onSelect(newSelectedItems);
            }
        }
    };

    return (
        <div className="relative flex items-end space-x-4">
            <div className="flex-1">
                <label htmlFor="dietary_restriction" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {label}
                </label>
                <input
                    type="text"
                    id="dietary_restriction"
                    name="dietary_restriction"
                    value={selectedItems.length > 0 ? selectedItems.map(item => item.name).join(', ') : ''}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Select Dietary Restriction"
                    readOnly
                />
            </div>
            <button
                id="dropdownItemButton"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                type="button"
                onClick={toggleDropdown}
            >
                Select
                <svg className="ml-2 w-4 h-4" fill="none" viewBox="0 0 20 20">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 8l5 5 5-5" />
                </svg>
            </button>
            {showDropdown && (
                <div
                    className="absolute z-10 mt-1 bg-white divide-y divide-gray-100 rounded shadow w-full dark:bg-gray-700"
                    style={{ top: '100%', left: 0, maxHeight: '20rem', overflowY: 'auto' }}
                >
                    <ul className="py-1 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownItemButton">
                        {items.map((item) => (
                            <li key={item.item_id}>
                                <a
                                    href="#"
                                    className={`block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white ${selectedItems.find(selected => selected.item_id === item.item_id) ? "bg-gray-200" : ""}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleSelectItem(item);
                                    }}
                                >
                                    {item.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}

DietaryRestrictionDropdown.propTypes = {
    onSelect: PropTypes.func.isRequired,
    selectedRestrictions: PropTypes.array,
    singleSelect: PropTypes.bool,
    label: PropTypes.string,
};

DietaryRestrictionDropdown.defaultProps = {
    singleSelect: true,
    label: 'Dietary Restriction',
};

export default DietaryRestrictionDropdown;
